import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    richtextContent = "richtextContent",
    linkTitle = "linkTitle",
    linkURL = "linkURL",
    background="background"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.richtextContent]: string;
        [fields.linkTitle]: string;
        [fields.linkURL]: LinkFieldValue;
        [fields.background]: string;
    };
}

export interface CENProductListDownlaodButtonStyles {
    quoteWrapper?: InjectableCss;
    linkStyles?: InjectableCss;
    richContentContainer: InjectableCss;
}

export const cenProductListDownlaodButtonStyles: CENProductListDownlaodButtonStyles = {
    richContentContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        width: 67%;
                    `,
                    null,
                    null,
                ])}

            h3 {
                color: #fff;
            }
        `,
    },
    quoteWrapper: {
        css: css`
            margin-top: 23px;
            margin-bottom: 100px;
            align-items: center;
            justify-content: space-between;
            display: flex;
            line-height: 28px;
            padding: 50px 100px;
            /* Dropshadows/Promo - MD */
            box-shadow: 0px 8px 16px rgba(38, 37, 37, 0.24);
            color: #fff;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        padding: 20px;
                        align-items: flex-start;
                    `,
                    css`
                        flex-direction: column;
                        padding: 20px;
                        align-items: flex-start;
                    `,
                    css`
                        padding: 50px 50px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    linkStyles: {
        css: css`
            padding: 8px 16px;
            width: 146px;
            height: 32px;
            background: #ffffff;
            border-radius: 16px;
            font-weight: 600;
            font-size: 14px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 15px;
                    `,
                    css`
                        margin-top: 15px;
                    `,
                    null,
                    null,
                    null,
                ])}
            line-height: 16px;
            > span {
                color: ${getColor("secondary")} !important;
            }
        `,
    },
};

const styles = cenProductListDownlaodButtonStyles;
type Props = OwnProps & WidgetProps;

export const CENProductListDownlaodButton: FC<Props> = ({ fields }) => {
    const { url } = useGetLink(fields.linkURL);

    return (
        <StyledWrapper {...styles.quoteWrapper}
         style={{background:fields.background}}>
            <StyledWrapper {...styles.richContentContainer}>
                {parse(transformContentHtml(fields.richtextContent), parserOptions)}
            </StyledWrapper>
            <Link href={url} {...styles.linkStyles}>
                {fields.linkTitle}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CENProductListDownlaodButton,
    definition: {
        group: "Product List",
        displayName: "CEN Product List Download",
        fieldDefinitions: [
            {
                name: fields.richtextContent,
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },

            {
                fieldType: "Translatable",
                name: fields.linkTitle,
                editorTemplate: "TextField",
                displayName: "Link title",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.linkURL,
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                displayName: "Link URL",
            },
            {
                name: fields.background,
                displayName: "Background Color",
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "linear-gradient(90deg, #8f0446 0%, #1d2d36 100%)",
            },
        ],
    },
};

export default widgetModule;
